/**
 * A name field that commits on Enter or on leaving it, and says why a name is
 * refused: a gate node's name, and a condition node's (Feature 79).
 */
import { useEffect, useState } from 'react';

import { Field } from '../../ui/Field.js';
import { Input } from '../../ui/finixt.js';

export function NameField({
  id,
  label,
  value,
  refusal,
  onCommit,
}: {
  id: string;
  label: string;
  value: string;
  refusal: (next: string) => string | null;
  onCommit: (next: string) => void;
}) {
  const [text, setText] = useState(value);
  useEffect(() => setText(value), [value]);
  const why = refusal(text);
  const commit = () => {
    if (why === null && text !== value) onCommit(text);
  };
  return (
    <Field id={id} label={label} error={why ?? undefined}>
      <Input
        id={id}
        className="mono"
        value={text}
        onChange={(e) => setText(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => {
          if (e.key === 'Enter') commit();
        }}
      />
    </Field>
  );
}
